import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';
import { theme, getGradient, getShadow } from '../../styles/theme';

const MessageContainer = styled(motion.div)`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;
  width: 100%;
  justify-content: flex-end;
  direction: ltr;  /* Force LTR for consistent layout - user messages on right */
`;

const UserBubble = styled.div`
  background: ${getGradient('primary')};
  color: white;
  padding: ${theme.spacing.lg} ${theme.spacing.xl};
  border-radius: ${theme.borderRadius.xl} ${theme.borderRadius.xl} ${theme.borderRadius.small} ${theme.borderRadius.xl};
  max-width: 80%;
  box-shadow: ${getShadow('button')};
  margin-left: auto;

  .content {
    font-weight: 500;
    line-height: 1.5;
    direction: auto;
    text-align: start;
    unicode-bidi: plaintext;
  }

  .timestamp {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    margin-top: 4px;
  }
`;

const Avatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: ${theme.borderRadius.round};
  background: ${getGradient('primary')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  svg {
    width: 20px;
    height: 20px;
    color: white;
  }
`;

const UserMessage = ({ message }) => {
  return (
    <MessageContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <UserBubble>
        <div className="content">
          {message.content}
        </div>
        {message.timestamp && (
          <div className="timestamp">
            {message.timestamp}
          </div>
        )}
      </UserBubble>
      <Avatar>
        <User />
      </Avatar>
    </MessageContainer>
  );
};

export default UserMessage;